import ProfileOverview from '~/components/common/user-profile/ProfileOverview';

const UserProfilePage = () => {
  return <ProfileOverview />;
};

export default UserProfilePage;
